import React, { useEffect, useState } from 'react'
import { Grid, } from '@material-ui/core';
import Controls from "../../../controls/Controls";
import { useForm, Form } from '../../../controls/useForm';
import { request } from '../../../../api/Service'
import { store } from '../../../../redux-store/store';


const initialFValues = {
    id: 0,
    bankName: '',
    accountNumber: '',
    accountName: ''
}


export default function AddAccountForm(props) {
    const { addAccount, recordForEdit } = props
    
    const validate = (fieldValues = values) => {
        let temp = { ...errors }
        if ('bankName' in fieldValues)
            temp.bankName = fieldValues.bankName ? "" : "This field is required."
        if ('accountNumber' in fieldValues)
            temp.accountNumber = fieldValues.accountNumber ? "" : "This field is required."
        if ('accountName' in fieldValues)
            temp.accountName = fieldValues.accountName !== "" ? "" : "Select a Country"
       
        setErrors({
            ...temp
        })

        if (fieldValues === values)
            return Object.values(temp).every(x => x === "")
    }

   

    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetForm
    } = useForm(initialFValues, true, validate);

    const handleSubmit = e => {
        e.preventDefault()
        if (validate()) {
            var result = { ...values, 'companyId': store.getState().persistReducer.companyId }
            addAccount(result, resetForm);
        }
    }

    useEffect(() => {
        if (recordForEdit !== null)
            setValues({
                ...recordForEdit
            })
    }, [recordForEdit])

    return (
        <Form onSubmit={handleSubmit}>
            <Grid container>
                <Grid item xs={12}>
                    <Controls.Input
                        name="bankName"
                        label="Bank Name"
                        value={values.bankName || ''}
                        onChange={handleInputChange}
                        error={errors.bankName}
                    />
                    <Controls.Input
                        label="Account Number"
                        name="accountNumber"
                        value={values.accountNumber || ''}
                        onChange={handleInputChange}
                        error={errors.accountNumber}
                    />
                      <Controls.Input
                        label="Account Name"
                        name="accountName"
                        value={values.accountName || ''}
                        onChange={handleInputChange}
                        error={errors.accountName}
                    />
                    
                      <div>
                        <Controls.Button
                            type="submit"
                            text="Submit" />
                    </div>
                  
                </Grid>
               
            </Grid>
        </Form>
    )
}
